import { useEffect } from 'react';
import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import { useNavigate } from "react-router-dom"
import LoginHeader from "../components/LoginHeader"
import { SERVICE_NAME } from '../constants/index';
import LogoHeader from "../components/LogoHeader";
import CustomButton from './CustomButton';

const LoginResetPasswordCompleted = ({view} : {view: 'company' | 'talent'}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()

  const redirectPage = (event: any) => {
    event.preventDefault()
    if (view == 'company')
      navigate("/company")
    else if (view == 'talent')
      navigate("/talent/login")
  }

  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[22.625rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view={view} page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[22.625rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <LoginHeader title="パスワードの再設定が完了しました"></LoginHeader>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
          
            <CustomButton type="button" onClick={redirectPage}>
              ログイン画面へ
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginResetPasswordCompleted;
